import { Flex } from 'antd';
import { Avatar, IF, Tooltip } from '../../common';
import styles from './useTableColumns.module.scss';
import CircularPill from 'components/lead-details-common/circularPill';
import Dropdown from 'common/drop-down/DropDown';

const RenderMultipleUser = ({ data: dat = [], itemToShow = 3 }) => {
  const data = dat?.map((member) => member?.user);
  if ((data || [])?.length === 0) return '-';

  if ((data || [])?.length === 1) {
    const { name, email, profile_picture, avatar_url } = data?.[0] || {};
    return (
      <Flex className={styles.userWithEmail} gap={8} justify="center" align="center">
        <Avatar size={32} name={name} isSystem={true} src={profile_picture || avatar_url} />
        <Flex vertical>
          <div className="body-12-medium">{name || '-'}</div>
          <div style={{ color: 'var(--user-main-text)' }} className="body-10-regular">
            {email || '-'}
          </div>
        </Flex>
      </Flex>
    );
  }

  const renderTooltipTitle = ({ name, profile_picture, email, avatar_url }) => (
    <Flex gap={8}>
      <Avatar size={32} name={name} isSystem src={profile_picture || avatar_url} />
      <Flex vertical>
        <div className="body-12-semibold">{name || '-'}</div>
        <div style={{ color: 'var(--user-main-text)' }} className="body-10-medium">
          {email || '-'}
        </div>
      </Flex>
    </Flex>
  );

  return (
    <Flex justify="center" align="center">
      {(data || [])?.slice(0, itemToShow)?.map((user, idx) => {
        const { name, profile_picture, avatar_url } = user;
        return (
          <Tooltip key={idx} title={renderTooltipTitle(user)}>
            <div style={{ marginLeft: '-10px', zIndex: idx }}>
              <Avatar size={36} name={name} isSystem={true} src={profile_picture || avatar_url} />
            </div>
          </Tooltip>
        );
      })}
      <IF condition={data?.length - itemToShow > 0}>
        <div className={styles.dropdownWrapper}>
          <Dropdown
            placement={'bottomRight'}
            DropDownButton={() => (
              <div>
                <CircularPill value={`+${data?.length - itemToShow}`} size={36} className="body-14-semibold" />
              </div>
            )}
            dropdownButtonStyle={{ marginLeft: '-10px', zIndex: itemToShow + 1, position: 'relative' }}
            overlayClassName={styles.dropdownOverlay}
            arrow={{ pointAtCenter: true }}
            dropdownRender={() => (
              <Flex vertical gap={12} className={styles.dropdownContainer}>
                {data.slice(itemToShow)?.map(({ name = '', profile_picture, avatar_url, email = '' }, idx) => {
                  return (
                    <Flex key={idx} gap={12} align="center">
                      <Avatar size={40} name={name} isSystem={true} src={profile_picture || avatar_url} />
                      <Flex vertical>
                        <div className="body-14-semibold">{name}</div>
                        <div style={{ color: 'var(--user-main-text)' }} className="body-12-medium">
                          {email}
                        </div>
                      </Flex>
                    </Flex>
                  );
                })}
              </Flex>
            )}
          />
        </div>
      </IF>
    </Flex>
  );
};

export default RenderMultipleUser;
